import { render, staticRenderFns } from "./BlockAccountModal.vue?vue&type=template&id=6f52d420"
import script from "./BlockAccountModal.vue?vue&type=script&lang=js"
export * from "./BlockAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports